import React from 'react';

export function WrapWordsAndLetters({ sentence }: { sentence: string }) {
  // Split the sentence into words, spaces, and "&", treating "&" explicitly as a word
  const regex = /(\b[\w]+\b|[&])/g;
  const wordsAndSymbols = sentence.split(regex).filter((item) => item);

  return (
    <>
      {wordsAndSymbols.map((item, index) => {
        // Check if the item is not just whitespace
        if (item.match(regex)) {
          // Wrap each word or "&" in a span, and further each letter in a nested span
          return (
            <span key={index} className="word">
              {item.split('').map((letter, letterIndex) => (
                <span key={letterIndex} className="letter">
                  {letter}
                </span>
              ))}
            </span>
          );
        } else {
          // Directly return whitespace and punctuation (excluding "&")
          return <React.Fragment key={index}>{item}</React.Fragment>;
        }
      })}
    </>
  );
}
